import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { ISummaryReport } from '@shared/interfaces';
import { SummaryReportDirective } from '@app/main/summary-report/directives/summary-report.directive';
import { ActivatedRoute, Router } from '@angular/router';
import { GuardService } from '@shared/services/guard.service';
import { CacheService, NavigationService, SummaryReportService } from '@shared/services';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs';
import { SummaryReportGroupByOption } from '@shared/enums';
import { TranslateService } from '@ngx-translate/core';
import { SummaryReportNewComponent } from '../summary-report-new/summary-report-new.component';

@Component({
    selector: 'app-summary-report-view',
    templateUrl: './summary-report-view.component.html',
    styleUrls: ['./summary-report-view.component.scss'],
    standalone: false
})
export class SummaryReportViewComponent extends SummaryReportDirective {
    constructor(
        protected guardService: GuardService,
        protected changeDetection: ChangeDetectorRef,
        protected cacheService: CacheService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected location: Location,
        protected navigationService: NavigationService,
        protected summaryReportService: SummaryReportService,
        protected dialog: MatDialog,
        private translateService: TranslateService
    ) {
        super(
            guardService,
            changeDetection,
            cacheService,
            router,
            route,
            location,
            navigationService,
            summaryReportService
        );
    }

    @Output() delete = new EventEmitter<ISummaryReport>();

    get isAdmin(): boolean {
        return this.guardService.isAdmin;
    }

    protected uploadFile(): void {
        this.dialog
            .open(SummaryReportNewComponent, {
                position: { top: '50px' },
                panelClass: 'custom-dialog'
            })
            .beforeClosed()
            .pipe(
                tap(async (success: boolean) => {
                    if (success) {
                        await this.reloadData();
                    }
                })
            )
            .subscribe();
    }

    protected getTabTranslation(tab: string): string {
        if (this.selectedGroupByOption === SummaryReportGroupByOption.year) {
            return tab;
        }
        return this.translateService.instant(`generic.filter.${tab}`);
    }

    public async reloadData(): Promise<void> {
        await this.loadData();
        this.group(this.selectedGroupByOption as SummaryReportGroupByOption);
        this.changeDetection.detectChanges();
    }
}
